const TOKEN_KEY = 'auth_token';

export const getStoredToken = (): string | null => localStorage.getItem(TOKEN_KEY);
export const storeToken = (token: string): void => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = (): void => localStorage.removeItem(TOKEN_KEY);

export const authorizedFetch = (input: string, init?: RequestInit): Promise<Response> => {
  const token = getStoredToken();
  return fetch(input, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};
